// extracted by mini-css-extract-plugin
module.exports = {"root":"Guides_root__F4sqP","header":"Guides_header__f3vCF","link":"Guides_link__4QqTi","guidesContainer":"Guides_guidesContainer__Fw3e0"};